export default [
  {
    title: '开关',
    key: 'enable',
    width: 52,
    type: 'basic',
    fixed: true
  },
  {
    title: '项目ID',
    key: 'projectId',
    width: 52,
    type: 'basic',
    fixed: true
  },
  {
    title: '项目名称',
    key: 'projectName',
    width: 220,
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: 126,
    type: 'basic',
    fixed: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 80,
    type: 'basic'
  },
  {
    title: '游戏',
    key: 'gameName',
    width: 126,
    overflow: true,
    type: 'basic'
  },
  {
    title: '账号',
    key: 'accountNames',
    width: 120,
    overflow: true,
    type: 'basic'
  },
  {
    title: '计划条数',
    key: 'havePlanNum',
    width: 72,
    overflow: true,
    type: 'basic'
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    type: 'report',
    width: 82
  },
  {
    title: '实际消耗',
    key: 'amount',
    type: 'report',
    width: 82
  },
  {
    title: '曝光量',
    key: 'pv',
    type: 'report',
    width: 88
  },
  {
    title: '点击数',
    key: 'clickNum',
    type: 'report',
    width: 82
  },
  {
    title: '点击率',
    key: 'clickRate',
    type: 'report',
    width: 82
  },
  {
    title: '激活数',
    key: 'downNum',
    type: 'report',
    width: 82
  },
  {
    title: '注册数',
    key: 'newUserNum',
    type: 'report',
    width: 82
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    type: 'report',
    width: 82
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    type: 'report',
    width: 94
  },
  {
    title: '激活成本',
    key: 'activeCost',
    type: 'report',
    width: 82
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    type: 'report',
    width: 82
  },
  {
    title: '激活转化率',
    key: 'activeRate',
    type: 'report',
    width: 81
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    type: 'report',
    width: 70
  },
  {
    title: '新增付费创角数',
    key: 'payRoleUserNum',
    type: 'report',
    width: 120
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt',
    type: 'report',
    width: 120
  },
  {
    title: '当日新增付费设备',
    key: 'payActiveDeviceNum',
    type: 'report',
    width: 132
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    type: 'report',
    width: 102
  },
  {
    title: '新设备付费率',
    key: 'payActiveDeviceNumRate',
    type: 'report',
    width: 102
  },
  {
    title: '新设备充值金额',
    key: 'newDeviceMoney',
    type: 'report',
    width: 120
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    type: 'report',
    width: 120
  },
  {
    title: '激活总流水',
    key: 'sumMoney',
    type: 'report',
    width: 102
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    type: 'report',
    width: 102
  },
  {
    title: '新设备回款率',
    key: 'newDeviceRate',
    type: 'report',
    width: 102
  },
  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    type: 'other',
    width: 70
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    type: 'other',
    width: 70
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    type: 'other',
    width: 70
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    type: 'other',
    width: 72
  },
  {
    title: '激活1日LTV',
    key: 'oneDayLtv',
    type: 'other',
    width: 89
  },
  {
    title: '激活3日LTV',
    key: 'threeDayLtv',
    type: 'other',
    width: 89
  },
  {
    title: '激活7日LTV',
    key: 'sevenDayLtv',
    type: 'other',
    width: 89
  },
  {
    title: '激活30日LTV',
    key: 'thirtyDayLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创角次留',
    key: 'twoDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角3留',
    key: 'threeDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角4留',
    key: 'fourDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角5留',
    key: 'fiveDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角6留',
    key: 'sixDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角7留',
    key: 'sevenDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角10留',
    key: 'tenDayCreateRetain',
    type: 'other',
    width: 72
  },
  {
    title: '创角15留',
    key: 'fifteenDayCreateRetain',
    type: 'other',
    width: 72
  },
  {
    title: '创角30留',
    key: 'thirtyDayCreateRetain',
    type: 'other',
    width: 72
  },
  {
    title: '创角1日LTV',
    key: 'oneDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角2日LTV',
    key: 'twoDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角3日LTV',
    key: 'threeDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角4日LTV',
    key: 'fourDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角5日LTV',
    key: 'fiveDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角6日LTV',
    key: 'sixDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角7日LTV',
    key: 'sevenDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角10日LTV',
    key: 'tenDayCreateLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创角15日LTV',
    key: 'fifteenDayCreateLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创角30日LTV',
    key: 'thirtyDayCreateLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 134
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 72,
    overflow: true
  }
]
